import { Button, Card, Col, Form, Input, Typography } from "antd";
import { send_email } from "helpers/sendEmail";
import ReactQuill from "react-quill";

interface FormValues {
  to_email: string;
  subject: string;
  message: string;
}

const SendMail = () => {
  const [form] = Form.useForm();
  const { Title } = Typography;

  const onFinish = async (values: FormValues) => {
    const { to_email, subject, message } = values;

    const response = await fetch("/email_templates/custom_email_template.html");

    const emailTemplate = await response.text();
    const htmlContent = emailTemplate.replace("{{customized_text}}", message);

    send_email(subject, htmlContent, to_email);

    form.resetFields();
  };

  return (
    <>
      <Card style={{ width: "100%" }}>
        <Title level={2}>Send e-post</Title>

        <Form form={form} onFinish={onFinish} layout="vertical">
          <Col span={24}>
            <Form.Item
              label="Mottaker:"
              name="to_email"
              rules={[
                {
                  required: true,
                  message: "Skriv inn mottaker",
                },
                {
                  pattern: new RegExp(/^[a-zA-ZæøåÆØÅ0-9@~`!@#$%^&*()_=+\\';:"/?>.<, -]+$/i),
                  message: "Kun bokstaver",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Emne:"
              name="subject"
              rules={[
                {
                  required: true,
                  message: "Skriv inn emne",
                },
                {
                  // pattern: new RegExp(/^[a-zA-ZæøåÆØÅ@~`!@#$%^&*()_=+\\';:"/?>.<, -]+$/i),
                  message: "Kun bokstaver",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Melding:"
              name="message"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <ReactQuill theme="snow" />
            </Form.Item>
          </Col>
          <Col span={24} style={{ textAlign: "right" }}>
            <Form.Item>
              <Button size="large" type="primary" htmlType="submit">
                Send mail
              </Button>
            </Form.Item>
          </Col>
        </Form>
      </Card>
    </>
  );
};

export default SendMail;
